<template>
    <form class="ChatForm" :class="{ active: isActive }" @submit.prevent="submit">
        <FormItem
            class="m-0"
            field="body"
            :form="form"
            help-block-class="text-left"
            help-block-label="Besked"
        >
            <TextareaAutosized
                v-model="form.body"
                :placeholder="placeholder"
                :disabled="disabled || locked"
                class="form-control-borderless outline-none px-5 py-2"
                required
            />
        </FormItem>

        <div v-if="!locked" class="px-5 py-2 text-right">
            <button class="btn-load" :disabled="form.busy">
                Send
            </button>
        </div>
    </form>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.ChatForm {
    @apply ChatForm flex items-center;

    button {
        color: @brand-primary;
        font-size: 16px;
        text-transform: uppercase;
        border: none;
        font-weight: bold;
        background: transparent;

        &:hover {
            color: darken(@brand-primary, 7%);
        }
    }
}

.ChatForm.active {
    @apply flex-col items-stretch;

    textarea {
        min-height: 40px;
        max-height: 50vh;
        overflow-y: auto !important;
        -webkit-overflow-scrolling: touch;
    }
}

.ChatForm:not(.active) .FormItem {
    @apply flex-1;
}

.ChatForm:not(.active) textarea {
    min-height: 45px !important;
    height: 45px !important;
}
</style>

<script type="text/babel">
import Focus from 'dashboard-js/directives/Focus'
import FormItem from 'dashboard-js/components/utilities/FormItem'
import TextareaAutosized from 'dashboard-js/components/utilities/TextareaAutosized'

export default {
    components: { TextareaAutosized, FormItem },

    directives: { Focus },

    props: ['form', 'disabled', 'locked'],

    computed: {
        isActive() {
            const body = this.form.body
            return body !== null && body.length > 0
        },

        placeholder() {
            return this.disabled ? 'Samtalen er låst for nye beskeder.' : 'Skriv en besked...'
        },
    },

    watch: {
        isActive(active) {
            this.$emit('active', active)
        },
    },

    methods: {
        submit() {
            this.$emit('submit')
        },
    },
}
</script>
